<!-- Bank mdoal  -->
<div class="modal fade" id="bankAccountModal" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
    <div class="modal-content">
      <button type="button" class="close close-modal" [attr.data-title]="'Close' | translate" (click)="closeModal()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
      <div class="modal-body">
        <div class="col_2 bgStyle profile_bank_section mt-75">
          <div class="currentStatus">
            <div id="tab-parent">
              <div class="tabs">
                <input type="radio" id="radio-1" name="tabs" checked />
                <label class="tabq" for="radio-1">{{'Bank / Microfinance / Mobile Money'| translate}}</label>
                <input type="radio" id="radio-2" name="tabs" />
                <!-- <label class="tabq" for="radio-2" (click)="open('money')">{{'Mobile Money'| translate}}</label> -->
                <span class="glider"></span>
              </div>
            </div>
            <form id="bankDetailsForm" [formGroup]="bankDetailsForm" (ngSubmit)="onSubmitBankForm()">
              <div class="line">
                <h4>{{'Bank Account Details'|translate}}</h4>
              </div>
              <div class="enroll_form">
                <div>
                  <div class="input_section">
                    <div class="container">
                      <div class="row">
                        <div class="col-md-12 col-lg-12 col-sm-12">
                          <label for="" class="text-center"> {{'Select Bank'| translate}}</label>
                          <div class="grid-parent">
                            <div class="grid-container">
                              <div class="grid-child" *ngFor="let bank of bankdata">
                                <input type="radio" id="bank{{ bank.bank_id }}" name="banks" formControlName="banks" value="{{ bank.bank_id }}" (change)="handleChange($event, bank.bank_name, bank.bank_id,bank.bank_type)">
                                <label for="bank{{ bank.bank_id }}">
                                  <img src="{{ bank.bank_logo }}">
                                </label>
                              </div>
                            </div>
                          </div>
                          <div *ngIf="isSubmitted && g.banks.errors" class="invalid-feedback">
                            <div *ngIf="g.banks.errors?.required">{{'This field is mandatory'|translate}}</div>
                          </div>
                        </div>
                      </div>
                      <div class="sub-container">
                        <div class="row">
                          <!-- <div class="col-md-6 col-lg-6 col-sm-12 mt-3">
                            <label *ngIf="bank" for="">{{'Account number'|translate}}</label>
                            <label *ngIf="!bank" for="">{{'Mobile number'|translate}}</label>
                            <input type="text" formControlName="account_number" [attr.maxlength]="bank ? 11 : 8">
                            <div *ngIf="!bank" class="text-sm textUnderMobile mt-2 ps-3">Note : {{'Mobile should start with valid numbers like 77, 76, 74, 66, 65, 62, 60, 61'|translate}}</div>
                            <div *ngIf="isSubmitted && bank && g.account_number.errors" class="invalid-feedback">
                              <div *ngIf="g.account_number.errors?.required">{{'This field is mandatory'|translate}}</div>
                              <div *ngIf="g.account_number.errors?.pattern">{{'This field should be valid'|translate}}</div>
                            </div>
                            <div *ngIf="isSubmitted && !bank && g.account_number.errors" class="invalid-feedback">
                              <div *ngIf="g.account_number.errors?.required">{{'This field is mandatory'|translate}}</div>
                              <div *ngIf="g.account_number.errors?.pattern">{{'This field should be valid'|translate}}</div>
                            </div>
                          </div>
                          <div class="col-md-6 col-lg-6 col-sm-12 mt-3">
                            <label for="">{{'Dénomination sociale'|translate}}</label>
                            <input type="text" formControlName="account_name" readonly [value]="setBankAccountName()">
                            <div *ngIf="isSubmitted && g.account_name.errors" class="invalid-feedback">
                              <div *ngIf="g.account_name.errors?.required">{{'This field is mandatory'|translate}}</div>
                              <div *ngIf="g.account_name.errors?.pattern">{{'This field should be valid'|translate}}</div>
                            </div>
                          </div>
                          <div class="col-md-6 col-lg-6 col-sm-12 mt-3">
                            <label for="">{{'Bank name'|translate}}</label>
                            <input readonly type="text" formControlName="bank_name">
                            <div *ngIf="isSubmitted && g.bank_name.errors" class="invalid-feedback">
                              <div *ngIf="g.bank_name.errors?.required">{{'This field is mandatory'|translate}}</div>
                              <div *ngIf="g.bank_name.errors?.pattern">{{'This field should be valid'|translate}}</div>
                            </div>
                          </div>
                          <div class="col-md-6 col-lg-6 col-sm-12 mt-3" *ngIf="bank">
                            <label for="">{{'Bank number'|translate}}</label>
                            <input type="text" formControlName="bank_number" maxlength="10">
                            <div *ngIf="isSubmitted && g.bank_number.errors" class="invalid-feedback">
                              <div *ngIf="g.bank_number.errors?.required">{{'This field is mandatory'|translate}}</div>
                              <div *ngIf="g.bank_number.errors?.pattern">{{'This field should be valid'|translate}}</div>
                            </div>
                          </div>
                          <div class="col-md-6 col-lg-6 col-sm-12 mt-3">
                            <label for="">{{'Bank counter'|translate}}</label>
                            <input type="text" formControlName="bank_counter" maxlength="20">
                            <div *ngIf="isSubmitted && g.bank_counter.errors" class="invalid-feedback">
                              <div *ngIf="g.bank_counter.errors?.required">{{'This field is mandatory'|translate}}</div>
                              <div *ngIf="g.bank_counter.errors?.pattern">{{'This field should be valid'|translate}}</div>
                            </div>
                          </div> -->
                          <!-- Bank slip shown for every bank (no bank-type conditional) -->
                          <div class="col-md-12 col-lg-12 col-sm-12 mt-3 bankslip">
                            <label for="bank_slip" class="upload_bankText">{{'Upload Bank Slip'|translate}}<span class="text-danger">*</span><span *ngIf="bank_slip" class="ml-1"><i class="fa fa-check-circle"></i></span></label>
                            <label for="bank_slip" id="bank_slipUpload" class="file-upload-card bank_slipUpload">
                              <div class="custom-container">
                                <p class="text-center">{{'Upload image or drop a file' | translate}}</p>
                                <i class="fa fa-upload " aria-hidden="true"></i>
                              </div>
                            </label>
                            <div *ngIf="!bank_slip" class="text-sm textUnderMobile">{{'File Size and file format'|translate}}</div>
                            <input class="input_hide" id="bank_slip" type="file" (change)="upload($event, 'bank_slip_upload')" data-target="bank_slip">
                            <a *ngIf="bank_slip" id="bank_slip_upload" href="{{bank_slip}}" target="_blank" class="viewFile text-center">
                              {{'Click to view File'| translate}}</a>
                            <div *ngIf="isSubmitted && g.bank_slip.errors" class="invalid-feedback d-block">
                              <div *ngIf="g.bank_slip.errors.required">{{'This field is mandatory'|translate}}.</div>
                              <div *ngIf="g.bank_slip.errors.size">{{'File Size should not be grater than 10 MB.'|translate}}</div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6 offset-md-3 mt-4 mb-5 text-center">
                            <button type="submit" id="submit_btn" class="btn btn-medium">{{'Save Changes' | translate}}</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
            <!--  <form id="mobileMoneyForm" *ngIf="mobileMoney" [formGroup]="mobileMoneyForm" (ngSubmit)="onSubmitBankForm()">
              <div class="line">
                <h4>{{'Mobile Money Account Details' | translate}}</h4>
              </div>
              <div class="enroll_form">
                <div>
                  <div class="input_section">
                    <div class="container">
                      <div class="row">
                        <div class="col-md-12 col-lg-12 col-sm-12">
                          <label for=""> {{'Select Bank'| translate}}</label>
                          <div class="grid-container">
                            <div class="grid-child" *ngFor="let moneybank of moneydata">
                              <input type="radio" id="mobile_money{{ moneybank.id }}" name="mobile_money" formControlName="mobile_money" value="{{ moneybank.value }}" (change)="handleChange($event, moneybank.name, 2)">
                              <label for="mobile_money{{ moneybank.id }}">
                                <img src="{{ moneybank.image }}">
                              </label>
                            </div>
                          </div>
                          <div *ngIf="isSubmitted && h.mobile_money.errors" class="invalid-feedback">
                            <div *ngIf="h.mobile_money.errors?.required">{{'This field is mandatory'|translate}}</div>
                          </div>
                        </div>
                      </div>
                      <div class="sub-container">
                        <div class="row">
                          <div class="col-md-6 col-lg-6 col-sm-12 mt-3">
                            <label for="">{{'Account name2'|translate}}</label>
                            <input type="text" formControlName="mobile_money_account_name">
                            <div *ngIf="isSubmitted && h.mobile_money_account_name.errors" class="invalid-feedback">
                              <div *ngIf="h.mobile_money_account_name.errors?.required">{{'This field is mandatory'|translate}}</div>
                              <div *ngIf="h.mobile_money_account_name.errors?.pattern">{{'This field should be valid'|translate}}</div>
                            </div>
                          </div>
                          <div class="col-md-6 col-lg-6 col-sm-12 mt-3">
                            <label for="">{{'Account number / Phone number'|translate}}</label>
                            <input type="text" formControlName="mobile_money_account_number">
                            <div *ngIf="isSubmitted && h.mobile_money_account_number.errors" class="invalid-feedback">
                              <div *ngIf="h.mobile_money_account_number.errors?.required">{{'This field is mandatory'|translate}}</div>
                              <div *ngIf="h.mobile_money_account_number.errors?.pattern">{{'This field should be valid'|translate}}</div>
                            </div>
                          </div>
                          <div class="col-md-6 col-lg-6 col-sm-12 mt-3">
                            <label for="">{{'Facility name'|translate}}</label>
                            <input type="text" formControlName="facility_name">
                            <div *ngIf="isSubmitted && h.facility_name.errors" class="invalid-feedback">
                              <div *ngIf="h.facility_name.errors?.required">{{'This field is mandatory'|translate}}</div>
                              <div *ngIf="h.facility_name.errors?.pattern">{{'This field should be valid'|translate}}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6 offset-md-3 mt-4 mb-5 text-center">
                          <button type="submit" id="submit_btn" class="btn btn-medium">{{'Save Changes' | translate}}</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
